import React from "react";
import { BUSINESS } from "@/data/content";

/**
 * Brand logo — uses the official AD monogram image.
 * variant: "mark" = monogram only (square), "lockup" = monogram + wordmark stack.
 */
export default function Logo({ size = 40, variant = "mark", className = "" }) {
  if (variant === "mark") {
    return (
      <img
        src={BUSINESS.logo}
        alt={`${BUSINESS.name} logo`}
        width={size}
        height={size}
        className={`object-contain ${className}`}
        style={{ height: size, width: size }}
        data-testid="brand-logo"
      />
    );
  }
  return (
    <img
      src={BUSINESS.logo}
      alt={`${BUSINESS.name} logo`}
      className={`object-contain ${className}`}
      data-testid="brand-logo"
    />
  );
}
